module.exports = __webpack_public_path__ + "img/arrow-down.15251d3f.svg";